import { createFileRoute, redirect } from "@tanstack/react-router";
import { type } from "arktype";
import { authClient } from "@/lib/authClient";
import { getSafeRedirectTarget } from "@/lib/redirectUtils";

const validateSearch = type({
  "to?": "string",
});

export const Route = createFileRoute("/")({
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession();
    if (session.data?.user) {
      throw redirect({
        to: "/dashboard",
      });
    }
    const redirectTarget = getSafeRedirectTarget(
      location.pathname,
      undefined,
      "/dashboard",
    );
    throw redirect({
      search: redirectTarget ? { to: redirectTarget } : {},
      to: "/login",
    });
  },
  validateSearch,
});
